/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

import CalculatorContext from "../../Context/CalculatorContext";

function ProtectedRoute({ children, conditionVariableName, redirectTarget }) {
  const contextValue = useContext(CalculatorContext);
  let noDataProvided = null;

  if (Array.isArray(conditionVariableName)) {
    noDataProvided = conditionVariableName.every((value) => {
      return contextValue[value] === "";
    });
  } else {
    noDataProvided = contextValue[conditionVariableName] === "";
  }

  if (noDataProvided) {
    return <Navigate to={redirectTarget} replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  conditionVariableName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  redirectTarget: PropTypes.string,
};

export default ProtectedRoute;
